export default "<section [ngClass]=\"{'container-fluid':fluid,'container':!fluid}\" style=\"padding: 0;\">\r\n\t<ng-content></ng-content>\r\n</section>\r\n"